import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Badge, Tag, Tooltip } from "antd";
import { HollowDotsSpinner } from "react-epic-spinners";
import { Link } from "react-router-dom";
import dayjsTZ from "../../../../../utils/dayjs";
import useAquamanDuty from "../../../../../hooks/useAquamanDuty";
import { getRandomColor } from "../Employees/Employees";
import "./AquamanAdminWidget.scss";

// Admin dashboard card: the assigned Aquaman per branch — this week first, then
// the upcoming turns, in the same list style as the birthday / EmployeeSince
// cards.
const AquamanAdminWidget = () => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const { loading, rosters } = useAquamanDuty({ upcoming: 8 });

  const branches = useMemo(
    () =>
      (rosters || []).map((roster) => ({
        ...roster,
        rows: [
          ...(roster.current ? [{ ...roster.current, isCurrent: true }] : []),
          ...(roster.upcoming || []).map((w) => ({ ...w, isCurrent: false })),
        ],
      })),
    [rosters]
  );

  if (loading) {
    return (
      <div className="aquamanAdminWidget loading">
        <HollowDotsSpinner color="#1da193" size={24} />
      </div>
    );
  }

  return (
    <div className={`aquamanAdminWidget ${isDarkMode ? "dark" : ""}`}>
      {branches.length === 0 ? (
        <div className="aquamanAdminEmpty">
          Nuk ka roster të Aquaman. <Link to="/aquaman">Krijo një</Link>.
        </div>
      ) : (
        branches.map((branch) => (
          <div className="aquamanBranch" key={branch.rosterId}>
            <div className="aquamanBranchHeader">
              <span>{branch.teamLabel}</span>
              <Link to="/aquaman">Menaxho</Link>
            </div>
            {branch.rows.length === 0 ? (
              <div className="aquamanAdminEmpty">Pa javë të planifikuara</div>
            ) : (
              <div className="aquamanBranchList">
                {branch.rows.map((week) => (
                  <div
                    className={`aquamanBranchItem ${week.isCurrent ? "current" : ""}`}
                    key={week.weekStart}
                  >
                    <Badge
                      className="name-badger"
                      color={week.isCurrent ? "#1da193" : getRandomColor()}
                      text={week.employeeName || "pa caktuar"}
                    />
                    <span className="aquamanBranchRange">
                      {dayjsTZ(week.weekStart).format("DD/MM")} -{" "}
                      {dayjsTZ(week.weekEnd).format("DD/MM")}
                    </span>
                    {week.isCurrent ? <Tag color="green">këtë javë</Tag> : null}
                    {week.status === "covered" ? (
                      <Tooltip title="Zëvendëson një koleg me leje.">
                        <Tag color="orange">zëvendësim</Tag>
                      </Tooltip>
                    ) : null}
                    {week.locked ? <Tag>kyçur</Tag> : null}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default AquamanAdminWidget;
